import {isValid} from 'date-fns';
import {isObject} from '../../modules/DNFORM/DNFORM-utils/DNFORM-utils';

export default {
	isNoValue(value) {
		return value === undefined || value === null || value === '' || value == false;
	},
	isEmptyValue(value) {
		return this.isNoValue(value) ||
			Array.isArray(value) && !value.length ||
			isObject(value) && Object.values(value).some(_value => _value === '');
	},
	isValidDate(value) {
		return isValid(new Date(value));
	},
	convertMegaByteToByte(value) {
		return value * Math.pow(1024, 2);
	},
	getFileExtensionFromFilename(filename) {
		return filename.split('.').pop();
	},
	hasFileWithForbiddenExtension(allowedFileExtensions, files) {
		return Array.from(files).some((file) => {
			const fileExtension = this.getFileExtensionFromFilename(file.name);
			return !allowedFileExtensions.includes(fileExtension);
		});
	},
	isPrimitiveValue(value) {
		if (typeof value === 'string') return true;
		if (typeof value === 'number' && isFinite(value)) return true;
		if (typeof value === 'boolean') return true;
		return false;
	}
};





// WEBPACK FOOTER //
// ../source/common/livr/livr-utils.js